import React, { useEffect, useState } from 'react';
import api from '../Api';

export default function LaporanRekapitulasi() {
  const [data, setData] = useState([]);
  const [grandTotal, setGrandTotal] = useState(null);

  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);

  // ================= FETCH DATA =================
  const fetchData = async (params = {}) => {
    try {
      setLoading(true);

      const res = await api.get('/report/cc-json', { params });

      setData(res.data.data || []);
      setGrandTotal(res.data.grand_total || null);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ================= FILTER =================
  const handleFilter = () => {
    const params = {};

    if (from && to) {
      params.from = from;
      params.to = to;
    }

    fetchData(params);
  };

  const handleReset = () => {
    setFrom('');
    setTo('');
    fetchData();
  };

  // ================= EXPORT EXCEL =================
  const handleExportExcel = async () => {
    try {
      setExportLoading(true);

      const params = {};
      if (from && to) {
        params.from = from;
        params.to = to;
      }

      const response = await api.get('/report/cc', {
        params,
        responseType: 'blob',
      });

      const blob = new Blob([response.data]);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'laporan_Rekapitulasi.xlsx');

      document.body.appendChild(link);
      link.click();
      link.remove();

      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      alert('Gagal export excel');
    } finally {
      setExportLoading(false);
    }
  };

  // ================= WARNA SOLVING RATIO =================
  const getRatioColor = (ratio) => {
    const r = Number(ratio);

    if (r >= 90) return '#63BE7B'; // hijau
    if (r >= 70) return '#C6E0B4'; // hijau muda
    if (r >= 50) return '#FFE699'; // kuning
    if (r >= 30) return '#F4B183'; // orange
    return '#F8696B'; // merah
  };

  return (
    <div className="container-fluid py-3 laporan-cc">
      <h4 className="fw-bold">LAPORAN REKAPITULASI</h4>

      {/* ================= FILTER ================= */}
      <div className="row g-2 mb-4 mt-2">
        <div className="col-md-2">
          <label className="form-label">From</label>
          <input type="date" className="form-control" value={from} onChange={(e) => setFrom(e.target.value)} />
        </div>

        <div className="col-md-2">
          <label className="form-label">To</label>
          <input type="date" className="form-control" value={to} onChange={(e) => setTo(e.target.value)} />
        </div>

        <div className="col-md-8 d-flex align-items-end gap-2">
          <button className="btn btn-primary" onClick={handleFilter}>
            Filter
          </button>

          <button className="btn btn-secondary" onClick={handleReset}>
            Reset
          </button>

          <button className="btn btn-success" onClick={handleExportExcel} disabled={exportLoading}>
            {exportLoading ? 'Generating...' : 'Generate Excel'}
          </button>
        </div>
      </div>

      {loading && <p>Loading...</p>}

      {/* ================= TABLE ================= */}
      <div className="table-responsive">
        <table className="table table-bordered table-sm text-center align-middle laporan-table">
          <thead className="table-light">
            <tr>
              <th rowSpan="2">No</th>
              <th rowSpan="2">KANTOR PELAYANAN</th>
              <th colSpan="3">TEKNIS</th>
              <th colSpan="3">ADMINISTRATIF</th>
              <th colSpan="3">REKAPITULASI</th>
              <th rowSpan="2">SOLVING RATIO</th>
            </tr>
            <tr>
              <th>Problem</th>
              <th>Closed</th>
              <th>On Progress</th>

              <th>Problem</th>
              <th>Closed</th>
              <th>On Progress</th>

              <th>Problem</th>
              <th>Closed</th>
              <th>On Progress</th>
            </tr>
          </thead>

          <tbody>
            {data.map((row, index) => (
              <tr key={index}>
                <td>{index + 1}</td>
                <td className="text-start fw-semibold">{row.wilayah}</td>

                <td>{row.teknis_problem}</td>
                <td>{row.teknis_closed}</td>
                <td>{row.teknis_on_progress}</td>

                <td>{row.adm_problem}</td>
                <td>{row.adm_closed}</td>
                <td>{row.adm_on_progress}</td>

                <td>{row.total_problem}</td>
                <td>{row.total_closed}</td>
                <td>{row.total_on_progress}</td>

                <td
                  style={{
                    backgroundColor: getRatioColor(row.solving_ratio),
                    fontWeight: 'bold',
                  }}
                >
                  {row.solving_ratio}%
                </td>
              </tr>
            ))}

            {/* ================= GRAND TOTAL ================= */}
            {grandTotal && (
              <tr className="fw-bold bg-light">
                <td colSpan="2">JUMLAH</td>

                <td>{grandTotal.teknis_problem}</td>
                <td>{grandTotal.teknis_closed}</td>
                <td>{grandTotal.teknis_on_progress}</td>

                <td>{grandTotal.adm_problem}</td>
                <td>{grandTotal.adm_closed}</td>
                <td>{grandTotal.adm_on_progress}</td>

                <td>{grandTotal.total_problem}</td>
                <td>{grandTotal.total_closed}</td>
                <td>{grandTotal.total_on_progress}</td>

                <td
                  style={{
                    backgroundColor: getRatioColor(grandTotal.solving_ratio),
                  }}
                >
                  {grandTotal.solving_ratio}%
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
